{
  "math_hint": "Math uses",
  "math_hint_katex": "Katex syntax"
}
